<template>
    <div>
        <jet-button @click="open = !open" class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">{{ actionName }}</jet-button>
        <alert-modal :open="open" :title="title" :message="message" :action-name="actionName" :model="model" :method="method" :named-route="namedRoute" />
    </div>
</template>
<script>
import JetButton from '@/Jetstream/Button'

import { ref } from 'vue'

export default {
    props: ['open', 'type', 'title', 'message', 'actionName', 'namedRoute', 'method', 'model'],

    setup() {
        const open = ref(false)

        return {
            open,
        }
    },

    components: {
        JetButton,
    }
}

</script>
